//////////////////////
// Read Permissions //
//////////////////////
import type { RoleList } from './defs';
import { Roles } from './defs';

export const viewButton: RoleList = [
  Roles.USER,
  Roles.MANAGER,
  Roles.PURCHASER,
  Roles.VIEW_ONLY,
  Roles.ACCOUNT_ADMIN,
  Roles.ACCOUNT_MANAGER,
  Roles.ASSET_MANAGER,
  Roles.BUSINESS_VIEW_ONLY,
  Roles.SYSTEM_ADMIN,
  Roles.SYSTEM_ADMIN_REGIONAL,
];

export const actionButton: RoleList = [
  Roles.MANAGER,
  Roles.ACCOUNT_ADMIN,
  Roles.ACCOUNT_MANAGER,
  Roles.ASSET_MANAGER,
  Roles.SYSTEM_ADMIN,
];
